import { useMutation, useQuery } from "@apollo/client";
import { Button, Grid, MenuItem, Paper, TextField } from "@mui/material";
import React from "react";
import { Field, Formik, useFormik } from "formik";
import * as Yup from "yup";
import {
  AGREGAR_CONCEPTOBANCARIO,
  EDITAR_CONCEPTOS_BANCO,
  LISTAR_SUBTIPO_EGRESOS,
  OBENER_CONCEPTOBANCARIO_EDIT,
} from "../../../../graphql/bancos";
const FrmEditarConceptosBanco = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
  id,
}) => {
  const {
    data: dconcepto,
    loading: lconcepto,
    error: econcepto,
  } = useQuery(OBENER_CONCEPTOBANCARIO_EDIT, {
    variables: {
      id: id,
    },
  });

  const [EditarConceptoBanco] = useMutation(EDITAR_CONCEPTOS_BANCO, {
    update(cache, { data: { EditarConceptoBanco } }) {
      const { obtenerConceptoBancos } = cache.readQuery({
        query: LISTAR_SUBTIPO_EGRESOS,
      });
      cache.writeQuery({
        query: LISTAR_SUBTIPO_EGRESOS,
        data: {
          obtenerConceptoBancos: [
            ...obtenerConceptoBancos,
            EditarConceptoBanco,
          ],
        },
      });
    },
  });

  if (lconcepto) return <h1>Obteniendo información</h1>;
  const { obtenerConceptoBancosEdit } = dconcepto;

  // const formik = useFormik({

  //   validationSchema: Yup.object({
  //     concepto: Yup.string().required("El concepto es requerido"),
  //   }),
  //   onSubmit: async (inputdata) => {
  //     try {
  //       const result = await agregarConceptoBanco({
  //         variables: {
  //           input: {
  //             concepto: inputdata.concepto,
  //             TipoConceptoId: parseInt(inputdata.TipoConceptoId),
  //           },
  //         },
  //       });
  //       setOpenSnackBar(true);
  //       setErrorGraph({
  //         mensaje: result.data.agregarConceptoBanco,
  //         severity: "success",
  //       });
  //       //Si todo sale bien reseteamos el formulario
  //       formik.resetForm();
  //     } catch (error) {
  //       setOpenSnackBar(true);
  //       setErrorGraph({ mensaje: error.message, severity: "error" });
  //     }
  //   },
  // });
  const onSubmit = async (values, formikValues) => {
    try {
     const dataInput = await EditarConceptoBanco({
      variables: {
        input: {
          id: parseInt(values.id), 
          concepto: values.concepto, 
          TipoConceptoId: parseInt(values.TipoConceptoId)
        }
      }
     })
     setOpenSnackBar(true);
     setErrorGraph({
       mensaje: dataInput.data.EditarConceptoBanco,
       severity: "success",
     });
     setOpenDialog(false);
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };
  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };
  return (
    <>
      <Formik
        initialValues={{
          id: obtenerConceptoBancosEdit.id,
          concepto: obtenerConceptoBancosEdit.concepto,
          TipoConceptoId: obtenerConceptoBancosEdit.TipoConceptoId,
        }}
        onSubmit={onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
          handleReset,
          isSubmitting,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Paper style={{ paddin: 10 }}>
              <Grid container alignItems="flex-start" spacing={3}>
                <Grid item xs={12}>
                  <Field name="concepto">
                    {({
                      field, // { name, value, onChange, onBlur }
                      form: { touched, errors },
                      meta,
                    }) => (
                      <TextField
                        {...field}
                        label="Concepto"
                        variant="standard"
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Field name="TipoConceptoId">
                    {({
                      field, // { name, value, onChange, onBlur }
                      form: { touched, errors },
                      meta,
                    }) => (
                      <TextField
                        select
                        fullWidth
                        {...field}
                        id="TipoConceptoId"
                        label="Tipo de Concepto"
                        variant="standard"
                        // onChange={formik.handleChange}
                        // value={formik.values.TipoConceptoId}
                      >
                        <MenuItem value="1">Ingreso</MenuItem>
                        <MenuItem value="2">Egreso</MenuItem>
                      </TextField>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <Button type="submit">Guardar</Button>
                  <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FrmEditarConceptosBanco;
